var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"icon",attrs:{"svg-inline":"","src":_vm.svgImgPath,"width":_vm.Width,"height":_vm.Height}})}
var staticRenderFns = []

export { render, staticRenderFns }